export const fmtUSD = (n, opts = {}) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const { compact = false, dp = 2 } = opts;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: compact ? "compact" : "standard",
    minimumFractionDigits: dp,
    maximumFractionDigits: dp,
  }).format(n);
};

export const fmtPct = (n, dp = 2) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const sign = n > 0 ? "+" : "";
  return `${sign}${Number(n).toFixed(dp)}%`;
};

export const fmtNum = (n, dp = 4) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return Number(n).toLocaleString("en-US", { maximumFractionDigits: dp });
};

export const relTime = (iso) => {
  if (!iso) return "—";
  const then = new Date(iso).getTime();
  const secs = Math.floor((Date.now() - then) / 1000);
  if (secs < 60) return `${secs}s ago`;
  const m = Math.floor(secs / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
};

export const gainClass = (n) =>
  n > 0 ? "text-gain" : n < 0 ? "text-loss" : "text-gray-500";
